document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-saza-bw-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-saza-bw-main]');
    gallery.querySelectorAll('[data-saza-bw-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var source = thumb.getAttribute('data-saza-bw-thumb');
        var alt = thumb.querySelector('img').getAttribute('alt');
        if (source && main) { main.src = source; main.alt = alt; }
        gallery.querySelectorAll('[data-saza-bw-thumb]').forEach(function (item) { item.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });
});
